import React from 'react';

const ModalContext = React.createContext({
  modalSourceElement: null,
  sourceComponent: '',
  actionArgs: [],
  setModalContext: null,
});

export default ModalContext;
